import React from "react";
import {  autoResizeTextArea } from "../../../utils/common.js";
import { withTranslation } from "react-i18next";
class InlineKrEditComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      krEditText: this.props.metricEdit
    };
    this.handleKrChange = this.handleKrChange.bind(this);
    this.onEnterPress = this.onEnterPress.bind(this);
  }
  componentDidMount() {
    this.textarea.focus();
    autoResizeTextArea(this.textarea);
  }

  handleKrChange(event) {
    //console.log('handleKrChange');
    let val = event.target.value;
    this.setState({
      krEditText: val
    }, () => {
      // Sending the value from the input target. 
      // SetState is an async function and sometimes, null value is send back as prop causing errors.
      // Safe way is to wait for setState to finish, and then handle promise function as follows
      this.props.handleSaveKrChange(val);
    });
  }

  onEnterPress(e) {
    //autoResizeTextArea(this.textarea);
    if (e.keyCode === 13) {
      e.preventDefault();
    }
  }

  render() {
    const { t, isKeyResult, labelText } = this.props;
    return (
      <div className="textarea-placeholder">
        <textarea
          aria-required="true"
          aria-invalid={!this.state.krEditText}
          className="inlineMetricEdit"
          id="editGoalNameclassId"
          key={this.props.krkeys}
          ref={node => (this.textarea = node)}
          defaultValue={this.state.krEditText}
          onChange={(event) => this.handleKrChange(event)}
          onKeyDown={(event) => this.onEnterPress(event)}
        />
        <label
          className={`${this.state.krEditText ? "screen-reader-only" : "showPlaceholder"} ${isKeyResult ? " kr-showPlaceholder" : ""}`}
          htmlFor="editGoalNameclassId"
        >
          {labelText}
          <span>*</span>
        </label>
      </div>
    );
  }
}

export default withTranslation()(InlineKrEditComp)
